"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onPresenceChangedHandlerForHost = onPresenceChangedHandlerForHost;
exports.onPresenceChangedHandlerForSpeaker = onPresenceChangedHandlerForSpeaker;
var _logger = require("@studio/logger");
var _constants = require("../constants");
var _getAttendeePresenceFunc = require("./getAttendeePresenceFunc");
var _subscribeToVolumeIndicator = require("../subscribeToVolumeIndicator");
function onPresenceChangedHandlerForHost(dispatch, actions, meetingSession, meetingResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var disconnectSource = actions.disconnectSource,
    setAttendeePresence = actions.setAttendeePresence,
    setAttendeeMuteStatus = actions.setAttendeeMuteStatus,
    setSourceInitializing = actions.setSourceInitializing,
    removePresenter = actions.removePresenter,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
  return function onPresenceChanged(attendeeId, present, _, dropped) {
    var setPresence = (0, _getAttendeePresenceFunc.getAttendeePresenceFunc)(dispatch, {
      disconnectSource: disconnectSource,
      setAttendeePresence: setAttendeePresence
    }, attendeeId);
    setPresence(attendeeId, present);
    if (present) {
      (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      dispatch(setSourceInitializing(attendeeId, {
        isInitializing: false
      }));
    } else {
      if (!dropped && attendeeId.includes('content')) {
        dispatch(removePresenter(attendeeId));
      }
      meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
    }
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      dropped: dropped,
      'studio.meeting.id': meetingId,
      title: "Attendee id: ".concat(attendeeId, " presence changed to ").concat(present, " in meeting id: ").concat(meetingId)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
  };
}
function onPresenceChangedHandlerForSpeaker(dispatch, actions, meetingSession) {
  var updateAttendeePresence = actions.updateAttendeePresence,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
  return function onPresenceChanged(attendeeId, present) {
    console.log("Attendee ID: ".concat(attendeeId, " Present: ").concat(present));
    if (!!setAttendeeVoiceIntensity) {
      if (present) {
        (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, null, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      } else {
        meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
      }
    }
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      title: "Attendee ID: ".concat(attendeeId, " Present: ").concat(present)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    dispatch(updateAttendeePresence(attendeeId, present));
  };
}